import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'

import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureMergePersonaModalModule } from '../lib/shared-feature-merge-persona-modal.module'
import { MergePersonaModalDocsComponent } from './merge-persona-modal-docs/merge-persona-modal-docs.component'
import { MergePersonaModalExampleComponent } from './merge-persona-modal-docs/merge-persona-modal-example.component'
import { PROVIDERS } from './providers'

@NgModule({
  declarations: [
    MergePersonaModalDocsComponent,
    MergePersonaModalExampleComponent
  ],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureMergePersonaModalModule
  ],
  exports: [MergePersonaModalDocsComponent],
  providers: PROVIDERS
})
export class SharedFeatureMergePersonaModalDocsModule {}
